export default __webpack_public_path__ + "static/media/hero-image.3de7c326.png";